import React, { useState } from 'react';
// @ts-ignore
import styles from './MultiSelectWithCheckList.module.scss';
import Select from '../../../../../Components/Base/Select/Select';
import { components } from 'react-select';
import Checkbox from '../../../../../Components/Base/Checkbox/Checkbox';
import useTranslation from '../../../../../Hooks/useTranslation';
import { MenuPlacement } from '../../../Enums/MenuPlacement.enum';

interface Props {
	options: any;
	onChange?: any;
	placeholder?: string;
	required?: boolean;
	value?: any;
	label?: string;
	firstUpper?: boolean;
	className?: string;
	portal?: boolean;
	isSearchable?: boolean;
	showItemsCounting?: boolean;
	menuPlacement?: MenuPlacement;
}

const InputOption = ({
	getStyles,
	Icon,
	isDisabled,
	isSelected,
	children,
	innerProps,
	...rest
}) => {
	const [isActive, setIsActive] = useState(false);
	const onMouseDown = () => setIsActive(true);
	const onMouseUp = () => setIsActive(false);
	const onMouseLeave = () => setIsActive(false);

	// styles
	let bg = 'transparent';
	if (isActive) bg = '#B2D4FF';

	const style = {
		alignItems: 'center',
		backgroundColor: bg,
		color: 'inherit',
		display: 'flex ',
	};

	// prop assignment
	const props = {
		...innerProps,
		onMouseDown,
		onMouseUp,
		onMouseLeave,
		style,
	};

	return (
		<components.Option
			{...rest}
			isDisabled={isDisabled}
			isSelected={isSelected}
			getStyles={getStyles}
			innerProps={props}>
			<div className={styles.wrapper}>
				<Checkbox value={isSelected} className={styles.checkbox} />
				<div className={styles.title}>{children}</div>
			</div>
		</components.Option>
	);
};

const MultiSelectWithCheckList: React.FC<Props> = ({
	options,
	onChange,
	placeholder = 'base.shared.pick',
	value,
	portal,
	isSearchable,
	showItemsCounting = true,
	menuPlacement,
}) => {
	const { t } = useTranslation();

	const components: any = {
		Option: InputOption,
	};

	if (showItemsCounting) {
		components.MultiValue = ({ children, ...innerProps }) => {
			const totalSelected = innerProps.getValue()?.length;
			const totalOptions = innerProps.options?.length;

			if (innerProps.index === 0) {
				return (
					<div>{`${t(
						'component.multiSelectWithCheckList.picked',
					)} ${totalSelected} ${t(
						'component.multiSelectWithCheckList.from',
					)} ${totalOptions}`}</div>
				);
			}

			return null;
		};
	}

	return (
		<Select
			options={options}
			isMulti
			components={components}
			closeMenuOnSelect={false}
			hideSelectedOptions={false}
			value={value}
			onChange={onChange}
			placeholder={t(placeholder)}
			portal={portal}
			isSearchable={true}
			menuPlacement={menuPlacement}
		/>
	);
};

export default MultiSelectWithCheckList;
